export default __webpack_public_path__ + "static/avatar-a717f2a14300e28dd0536acba1689822.jpg";